module.exports = __webpack_public_path__ + "img/warning.cf436366.svg";